import { HaircutType, SpreadsheetMapping, SpreadsheetSettlementVenue } from 'api'
import { gatherIssues, parseEnum, parseNumber, parseString } from '../upload/model'
import { Locale, Translation } from 'locale'
import { IncomingPriceUpload, IncomingSpreadsheetParseResult, IncomingSpreadsheetParseRowResult } from './IncomingUploadDialog'

export const NonParsableIncomingSettlementVenueTypes = [SpreadsheetSettlementVenue.Direct]

export function parseIncomingSpreadsheet(
  filename: string,
  rows: any[],
  spreadsheetMapping: SpreadsheetMapping
): IncomingSpreadsheetParseResult<IncomingPriceUpload> {
  return rows.reduce<IncomingSpreadsheetParseResult<IncomingPriceUpload>>(
    (spreadsheetResult, row, rowIdx) => {
      const rowResult = parseRow(row, rowIdx + 1, spreadsheetMapping)

      spreadsheetResult.issues.push(...rowResult.parseIssues)

      if (rowResult.parseIssues.length === 0) {
        spreadsheetResult.priceUploads.push(rowResult.priceUpload)
      }

      return spreadsheetResult
    },
    { filename, rows, issues: [], priceUploads: [] }
  )
}

const parseRow = (
  row: any,
  rowNum: number,
  spreadsheetMapping: SpreadsheetMapping
): IncomingSpreadsheetParseRowResult<IncomingPriceUpload> => {
  const rfqId = parseString(row, rowNum, spreadsheetMapping.rfqId, Locale.translate(Translation.TC_RFQ_ID), true)
  const negotiationId = parseString(row, rowNum, spreadsheetMapping.negotiationId, Locale.translate(Translation.TC_NEGOTIATION_ID), true)
  const rate = parseNumber(row, rowNum, spreadsheetMapping.rate, Locale.translate(Translation.TC_RATE), true)
  const haircut = parseNumber(row, rowNum, spreadsheetMapping.haircut, Locale.translate(Translation.TC_HAIRCUT), true)
  const haircutType = parseEnum<HaircutType>(
    row,
    rowNum,
    spreadsheetMapping.haircutType,
    spreadsheetMapping.haircutType.values,
    Locale.translate(Translation.TC_HAIRCUT_TYPE),
    false,
    true
  )

  const settlementType = parseEnum<SpreadsheetSettlementVenue>(
    row,
    rowNum,
    spreadsheetMapping.settlementVenue,
    spreadsheetMapping.settlementVenue.values,
    Locale.translate(Translation.TC_SETTLEMENT_TYPE),
    false,
    false
  )
  return {
    parseIssues: gatherIssues(rfqId, rate, haircut),
    priceUpload: {
      rfqId: rfqId.isValue ? rfqId.value : null,
      negotiationId: negotiationId.isValue ? negotiationId.value : null,
      rate: rate.isValue ? rate.value : null,
      haircut: haircut.isValue ? haircut.value : null,
      haircutType: haircutType.isValue ? haircutType.value : null,
      settlementType:
        settlementType.isValue && !NonParsableIncomingSettlementVenueTypes.includes(settlementType.value) ? settlementType.value : null,
      dataIssues: []
    }
  }
}
